import { useResolveCaseVariableQueryState } from 'dashboard/redux/api/cases';

export const useSelectResolvedVariable = (
  token: string,
  variableDefinitionToken: string,
  resolveVariable: typeof useResolveCaseVariableQueryState,
) => {
  return resolveVariable(
    { caseToken: token, variableDefinitionToken },
    {
      selectFromResult: ({ data }) => ({
        data: data,
      }),
    },
  );
};
